import React, { useEffect, useState } from "react";
import { Variables } from "../../Variations/Variations";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import SlideGallery from "./SlideGallery";
import { toast } from "react-toastify";
import Util from "../../Classes/Util";
import { AiOutlineRight } from "react-icons/ai";

const ManageSlider = () => {
  const permissions = Util.decrypt(localStorage.getItem("Permissions"));
  const { SlideID } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [url, setUrl] = useState("");
  const [showContent, setShowContent] = useState(false);
  const [publishDate, setPublishDate] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [media, setMedia] = useState("");
  const [showingMedia, setShowingMedia] = useState("");
  const [sliders, setSliders] = useState([]);
  const [selectedSliders, setSelectedSliders] = useState([]);

  // Build react-select options
  const sliderOptions = sliders.map(s => ({
    value: s.SliderId,
    label: s.SliderName
  }));

  const handleContent = e => {
    setShowContent(e.target.checked);
  };
  console.log(selectedSliders)

  const handlePublish = e => {
    if (e.target.value) {
      setPublishDate(e.target.value);
      setIsPublished(true);
    }
  };

  const isValid = () => {
    if (!title.trim()) {
      toast.error("Slide Name Required");
      document.getElementById("title").focus();
      return false;
    }
    if (!media) {
      toast.error("Please choose a media for your slide");
      // Assuming SlideGallery sets media via an element with id "media"
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!isValid()) return;

    const payload = {
      Title: title,
      PublishDate: publishDate,
      IsPublished: isPublished,
      Media: media,
      ShowContent: showContent,
      Subtitle: subtitle,
      Url: url
    };

    const assignBody = selectedSliders.map(opt => ({
      SlideID: SlideID === "0" ? null : parseInt(SlideID, 10),
      SliderId: opt.value
    }));

    const doAssign = newId =>
      fetch(
        `${Variables.API_URL}Slide/AssignSlidersToSlide/${newId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(
            assignBody.map(item => ({
              SlideID: item.SlideID ?? newId,
              SliderId: item.SliderId
            }))
          )
        }
      );

    if (SlideID === "0") {
      // Add new slide
      fetch(`${Variables.API_URL}Slide/AddSlide`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(newId => doAssign(newId))
        .then(res => {
          if (res.ok) {
            toast.success("Added Successfully");
            navigate("/admin/gazelle/Slides");
          } else {
            toast.error("Failed to assign sliders");
          }
        })
        .catch(() => toast.error("Failed to add slide"));
    } else {
      // Update existing slide
      fetch(`${Variables.API_URL}Slide/UpdateSlide/${SlideID}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      })
        .then(res => {
          if (!res.ok) throw new Error();
          return doAssign(SlideID);
        })
        .then(res => {
          if (res.ok) {
            toast.success("Updated Successfully");
            navigate("/admin/gazelle/Slides");
          } else {
            toast.error("Failed to assign sliders");
          }
        })
        .catch(() => toast.error("Failed to update slide"));
    }
  };

  // Fetch slide data for edit
  async function getSlide() {
    const resp = await fetch(`${Variables.API_URL}Slide/GetSlide/${SlideID}`);
    if (!resp.ok) throw new Error();
    const data = await resp.json();
    setTitle(data.Title);
    setSubtitle(data.Subtitle);
    setUrl(data.Url);
    setMedia(data.Media);
    setShowingMedia(data.Image);
    setShowContent(data.ShowContent);
    setPublishDate(data.PublishDate);
    setIsPublished(data.IsPublished);
  }

  // Fetch all sliders and, if editing, the assigned ones
  async function getSliders() {
    const resp = await fetch(`${Variables.API_URL}Slider/GetSliders`);
    if (!resp.ok) throw new Error();
    const list = await resp.json();
    setSliders(list);
    if (SlideID !== "0") {
      const aResp = await fetch(
        `${Variables.API_URL}Slide/GetAssignedSliders/${SlideID}`
      );
      if (!aResp.ok) throw new Error();
      const assigned = await aResp.json();
      setSelectedSliders(
        assigned.map(item => ({ value: item.SliderId, label: item.SliderName }))
      );
    }
  }

  useEffect(() => {
    if (SlideID !== "0") {
      getSlide().catch(() => toast.error("Failed to load slide"));
    }
    getSliders().catch(() => toast.error("Failed to load sliders"));
  }, []);

  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row mb-3">
          <div className="col-12">
            <h2>{SlideID === "0" ? "Add Slide" : `Manage ${title} Slide`}</h2>
            <ul className="portalPath">
              <li>Home <AiOutlineRight /></li>
              <li>
                <Link to="/admin/gazelle/Slides">Slides <AiOutlineRight /></Link>
              </li>
              <li>{SlideID === "0" ? "Add Slide" : "Manage Slide"}</li>
            </ul>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="row mb-4">
              <div className="col-12 text-end">
                <NavLink to="/admin/gazelle/Slides" className="btn btn-secondary">
                  Cancel
                </NavLink>
                {permissions.ManageSlide && (
                  <button
                    type="button"
                    className="btn btn-primary ms-2"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>

            {/* Slide Name */}
            <div className="mb-4">
              <label className="form-label">Slide Name <span className="required">*</span></label>
              <input
                id="title"
                type="text"
                className="form-control"
                value={title}
                onChange={e => setTitle(e.target.value)}
              />
            </div>

            {/* Slide Subtitle */}
            <div className="mb-4">
              <label className="form-label">Slide Subtitle</label>
              <input
                type="text"
                className="form-control"
                value={subtitle}
                onChange={e => setSubtitle(e.target.value)}
              />
            </div>

            {/* Slide URL */}
            <div className="mb-4">
              <label className="form-label">Slide URL</label>
              <input
                type="text"
                className="form-control"
                value={url}
                onChange={e => setUrl(e.target.value)}
              />
            </div>

            {/* SlideGallery (media picker) */}
            {permissions.ManageSlide && (
              <div className="mb-4">
                <SlideGallery
                  setMedia={setMedia}
                  setShowingMedia={setShowingMedia}
                />
              </div>
            )}

            {/* Preview */}
            {showingMedia && (
              <div className="mb-4">
                <img
                  src={Variables.API_PUBLISHED + showingMedia}
                  className="img-thumbnail"
                  alt="Slide preview"
                />
              </div>
            )}

            {/* Publish Date */}
            {permissions.PublishSlide && (
              <div className="mb-4">
                <label className="form-label">Published Date</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  value={publishDate}
                  onChange={handlePublish}
                />
              </div>
            )}

            {/* Sliders multi-select */}
            <div className="mb-4">
              <label className="form-label">Sliders</label>
              <Select
                options={sliderOptions}
                value={selectedSliders}
                onChange={setSelectedSliders}
                isMulti
                placeholder="Select slides…"
              />
            </div>

            {/* Show content checkbox */}
            <div className="form-check mb-4">
              <input
                id="showContent"
                type="checkbox"
                className="form-check-input"
                checked={showContent}
                onChange={handleContent}
              />
              <label className="form-check-label" htmlFor="showContent">
                Show Content
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageSlider;
